<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="mb-2">
      <PageTitle title="Selecionar produtos" />
      <span v-observe-visibility="menuPosition"></span>
    </b-col>
    <b-col cols="12">
      <div>
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=4GRuIu_twmY&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=30', 
            title: 'Selecionar produtos' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
        <a
          class="btn btn-success"
          href="https://api.construp.com.br/assets/Selecionar Produtos (1).pdf"
          target="_blank"
          download
        >
          <i class="fas fa-file-pdf c-white"></i> Baixar Manual
        </a>
    </div>
    </b-col>

    <b-col cols="12" class="mt-4">
      <b-card
        header="Filtros"
        header-text-variant="white"
        header-tag="header"
        header-bg-variant="secondary"
      >
        <ProductsFilters
          v-model="filters"
          :externalLoading="loading"
          @search="get(false)"
          @searchProductsByFamilyId="getValid()"
        />
      </b-card>
    </b-col>
    
    <b-col cols="12" class="mt-4">
      <span class="lineSelected itensText" @click="buscaStatus = 'ativo'"
        >Produtos ativos</span
      >
      <span class="lineDanger itensText" @click="buscaStatus = 'inativo'"
        >Produtos inativos</span
      >
      <span class="lineEdit itensText" @click="buscaStatus = 'marcado'"
        >Produtos marcados</span
      >
    </b-col>

    <b-col cols="12" class="my-4">
      <b-card
        header="Produtos encontrados"
        header-text-variant="white"
        header-tag="header"
        header-bg-variant="secondary"
      >
        <b-col cols="12">
          <b-row class="d-flex align-items-center justify-content-between">
            <b-col class="">
              <UploadProductsSpreadsheet class="mr-1" />
            </b-col>

            <b-col
              class="text-right d-flex align-items-center justify-content-sm-center justify-content-md-center justify-content-lg-end flex-wrap"
              style="gap: 10px"
            >
              <b-button
                variant="warning"
                class="mr-2 btnAcaoProd"
                @click="cleanSelection()"
              >
                <i class="fas fa-trash mr-2"></i>
                Limpar seleção
              </b-button>

              <b-button
                v-if="!isSmallWindow"
                variant="success"
                class="btnAcaoProd"
                @click="save()"
                :disabled="
                  loading || !Object.keys(fields.checkedCheckboxes).length
                "
              >
                <i class="fas fa-save mr-2"></i>
                Salvar produtos selecionados
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-card>
    </b-col>
    <b-col 
      cols="12" 
      v-if="
        this.columnHide.codbar || 
        this.columnHide.marca ||
        this.columnHide.unidade ||
        this.columnHide.photo
      "
    >
      <h5 class="mb-3">Colunas Ocultas</h5>
      <span v-if="this.columnHide.photo" class="lineSelectedWarning itensText" @click="showColumn('photo')">
        Detalhes
      </span>

      <span v-if="this.columnHide.codbar" class="lineSelectedWarning itensText" @click="showColumn('codbar')">
        Cod. Barras
      </span>
      
      <span v-if="this.columnHide.marca" class="lineSelectedWarning itensText" @click="showColumn('marca')">
        Marca
      </span>
      
      <span v-if="this.columnHide.unidade" class="lineSelectedWarning itensText" @click="showColumn('unidade')">
        Tipo
      </span>

    </b-col>
    <span v-observe-visibility="pagePosition">.</span>
    <b-col cols="12" class="p-0">
      <b-table
        striped
        bordered
        hover
        thead-class
        show-empty
        responsive
        fixed
        id="selectProductsTable"
        empty-text="Sem produtos encontrados"
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
        :tbody-tr-class="validItens"
        :thead-tr-class="'position: sticky'"
        :tbody-tr-attr="verItens"
      >
        <template #head()="data">
          <thead>
            <tr>
              <th :class="!btnVisible && !menuVisible ?  'headTableFixed': 'headTable'">
                
                <div v-if="data.field.key === 'withdrawalInOneDay'">
                  <i class="fas fa-question-circle question-tool-tips" id="tooltip-target-1"></i>
                  {{ textWrap(data.label) }}
                  <b-tooltip placement="left" target="tooltip-target-1" triggers="hover">
                    Selecione se o produto está
                    disponível para retirada em
                    24h no app.
                  </b-tooltip>
                </div>

                <div v-else-if="data.field.key === 'codInternoAdd'">
                  <i class="fas fa-question-circle question-tool-tips" id="tooltip-target-2"></i>
                  {{ textWrap(data.label) }}
                  <BTooltip target="tooltip-target-2" placement="left" triggers="hover">
                    Insira o código interno do
                    produto que é utilizado em
                    seu sistema (opcional).
                  </BTooltip>
                </div>

                <div v-else-if="data.field.key === 'discont'">
                  <i class="fas fa-question-circle question-tool-tips" id="tooltip-target-3"></i>
                  {{ textWrap(data.label) }}
                  <BTooltip target="tooltip-target-3" placement="right" triggers="hover">
                    Insira em porcentagem o desconto para
                    pagamento á vista (pix e boleto) por
                    produto (opcional).
                  </BTooltip>
                </div>

                <div v-else-if="data.field.key === 'quantityStock'">
                  <i class="fas fa-question-circle question-tool-tips" id="tooltip-target-4"></i>
                  {{ textWrap(data.label) }}
                  <BTooltip target="tooltip-target-4" placement="right" triggers="hover">
                    Informe se deseja que o sistema faça o
                    gerenciamento do seu estoque, caso a
                    resposta for não, o sistema deixará vender
                    sem limitado, se sim é só inserir a
                    quantidade em estoque.
                  </BTooltip>
                </div>
                
                <div v-else>
                  {{ textWrap(data.label) }}
                  <div class="mt-1" v-if="!isSmallWindow">
                    <b-button
                      size="sm"
                      pill variant="outline-warning"
                      @click="hideColumn(data)"
                      v-if="
                        data.field.key == 'photo' ||
                        data.field.key == 'codbar' ||
                        data.field.key == 'marca' ||
                        data.field.key == 'unidade'
                      "
                    >
                      <i class="fas fa-eye-slash"></i>
                    </b-button>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #cell(photo)="data">
          <span @click="showModal(data.item.id, data.item.produto, data.item.familia ? data.item.familia : '')">
            <img
              :src="
                linkFotos(
                data.item && data.item.origem && data.item.origem != null && data.item.origem != '' ? data.item.origem : 'Construp'
                ) +
                data.item.produto_fotos[0].foto_png
              "
              :alt="data.item.produto"
              class="imgWidth"
            />
          </span>
        </template>

        <template #cell(produto)="data">
          <span> {{ data.item.nome_extra && data.item.nome_extra != null ? data.item.nome_extra : data.item.produto }} </span>
        </template>

        <template #cell(qtdMeters)="data">
          <span> {{ data.item.qtd_metros !== null ? data.item.qtd_metros : 0 }} </span>
        </template>

        <template #cell(marca)="data">
          <span style="text-transform: capitalize">
            {{ 
              data.item.marca_extra && data.item.marca_extra != null ?
              data.item.marca_extra : formatMarca(data.item.marca) 
            }}
          </span>
        </template>

        <template #cell(priceSalesFormat1)="data">
          <div
            class="d-flex align-items-center justify-content-center flex-wrap"
          >
            <InputMoney
              v-if="fields.selectedProducts[`${data.item.id}`]"
              :disabled="!data.item.unidade"
              class="mt-1"
              v-model="
                fields.selectedProducts[`${data.item.id}`].priceSalesFormat1
              "
            />
            <b-badge
              v-if="fields.checkedCheckboxes[`${data.item.id}`]"
              class="pointer text-center mt-1"
              href="#"
              title="Preços customizados"
              @click="
                openSelectedProductPricesEdit({
                  selectedProductId: null,
                  productName: data.item.produto,
                  productId: data.item.id,
                  alreadyCreatedPrices:
                    fields.selectedProducts[`${data.item.id}`].customPrices,
                })
              "
            >
              <i class="fas fa-tag"></i>
            </b-badge>

            <div
              v-if="
                data.item.statusSelected && data.item.statusSelected != null
              "
            >
              R$ {{ formatMoneyUn(data.item.price_sales_format_1) }}
            </div>
          </div>
        </template>

        <template #cell(priceSalesFormat2)="data">
          <InputMoney
            v-if="fields.selectedProducts[`${data.item.id}`]"
            :disabled="!data.item.salesFormat2"
            v-model="
              fields.selectedProducts[`${data.item.id}`].priceSalesFormat2
            "
          />
        </template>

        <template #cell(quantityStock)="data">
          <input
            v-if="fields.selectedProducts[`${data.item.id}`]"
            class="form-control"
            :style="fields.selectedProducts[`${data.item.id}`].quantityValid ? 'display:block' : 'display:none'"
            type="number"
            :placeholder="0"
            v-model.number="fields.selectedProducts[`${data.item.id}`].quantityStock"
          >
          <b-form-checkbox
            v-if="fields.selectedProducts[`${data.item.id}`]"
            v-model="fields.selectedProducts[`${data.item.id}`].quantityValid"
            switch
          >
            {{ fields.selectedProducts[`${data.item.id}`].quantityValid ? ' Sim' : ' Não' }}
          </b-form-checkbox>

          <div v-if="data.item.statusSelected && data.item.statusSelected != null">
            {{ data.item.manage_stock == true ? data.item.quantity_stock : 'Não' }}
          </div>
        </template>

        <template #cell(withdrawalInOneDay)="data">
          <div
            v-if="data.item.statusSelected && data.item.statusSelected != null"
          >
            {{ data.item.withdrawal_in_one_day == true ? 'Sim' : 'Não' }}
          </div>

          <div v-else>
            <b-form-checkbox
              v-if="fields.selectedProducts[`${data.item.id}`]"
              v-model="
                fields.selectedProducts[`${data.item.id}`].withdrawalInOneDay
              "
              switch
            >
              {{
                fields.selectedProducts[`${data.item.id}`].withdrawalInOneDay
                  ? ' Sim'
                  : ' Não'
              }}
            </b-form-checkbox>
            <span v-else>{{
              data.item.withdrawalInOneDay ? 'Sim' : 'Não'
            }}</span>
          </div>
        </template>
        
        <template #cell(isExclusivePrice)="data">
          <div
            v-if="data.item.statusSelected && data.item.statusSelected != null"
          >
            {{ data.item.is_exclusive_price == true ? 'Sim' : 'Não' }}
          </div>

          <div v-else>
            <b-form-checkbox
              v-if="fields.selectedProducts[`${data.item.id}`]"
              v-model="
                fields.selectedProducts[`${data.item.id}`].isExclusivePrice
              "
              switch
            >
              {{
                fields.selectedProducts[`${data.item.id}`].isExclusivePrice
                  ? ' Sim'
                  : ' Não'
              }}
            </b-form-checkbox>
            <span v-else>{{
              data.item.isExclusivePrice ? 'Sim' : 'Não'
            }}</span>
          </div>
        </template>
        
        <template #cell(isCaliper)="data">
          <div
            v-if="data.item.statusSelected && data.item.statusSelected != null"
          >
            {{ data.item.is_caliper == true ? 'Sim' : 'Não' }}
          </div>

          <div v-else>
            <b-form-checkbox
              v-if="fields.selectedProducts[`${data.item.id}`]"
              v-model="
                fields.selectedProducts[`${data.item.id}`].isCaliper
              "
              switch
            >
              {{
                fields.selectedProducts[`${data.item.id}`].isCaliper
                  ? ' Sim'
                  : ' Não'
              }}
            </b-form-checkbox>
            <span v-else>{{
              data.item.isCaliper ? 'Sim' : 'Não'
            }}</span>
          </div>
        </template>

        <template #cell(motorcycle)="data">
          <div
            v-if="data.item.statusSelected && data.item.statusSelected != null"
          >
            {{ data.item.motorcycle == true ? 'Sim' : 'Não' }}
          </div>

          <div v-else>
            <b-form-checkbox
              v-if="fields.selectedProducts[`${data.item.id}`]"
              v-model="
                fields.selectedProducts[`${data.item.id}`].motorcycle
              "
              switch
            >
              {{
                fields.selectedProducts[`${data.item.id}`].motorcycle
                  ? ' Sim'
                  : ' Não'
              }}
            </b-form-checkbox>
            <span v-else>{{
              data.item.motorcycle ? 'Sim' : 'Não'
            }}</span>
          </div>
        </template>

        <template #cell(codInternoAdd)="data">
          <div v-if="data.item.codInterno && data.item.codInterno != null">
            {{ data.item.codInterno }}
          </div>

          <div v-else>
            <input
              v-if="fields.selectedProducts[`${data.item.id}`]"
              class="form-control"
              type="text"
              v-model="fields.selectedProducts[`${data.item.id}`].codInterno"
              @blur="validCodInterno(`${data.item.id}`)"
              @keyup.enter="validCodInterno(`${data.item.id}`)"
            />
          </div>
        </template>

        <template #cell(discont)="data">
          <b-input
            v-if="fields.selectedProducts[`${data.item.id}`]"
            class="form-control"
            type="text"
            v-mask="['#', '##']"
            placeholder="0 %"
            v-model="fields.selectedProducts[`${data.item.id}`].discont"
          ></b-input>
          <div
            v-if="data.item.statusSelected && data.item.statusSelected != null"
          >
            {{ data.item.discont == null ? '0' : data.item.discont }}
          </div>
        </template>

        <template #cell(actions)="data">
          <span v-if="whatClerkPermission()">
            <b-form-checkbox
              v-if="
                (!data.item.statusSelected || data.item.statusSelected == null) && !isSmallWindow
              "
              class="text-center"
              v-model="fields.checkedCheckboxes[`${data.item.id}`]"
              :value="true"
              :unchecked-value="false"
              @change="
                ($event) => handleSelection($event, data.item.id, data.item)
              "
            >
            </b-form-checkbox>
            <b-button
              size="sm"
              variant="outline-primary"
              v-if="
                (!data.item.statusSelected || data.item.statusSelected == null) && isSmallWindow
              "
              @click="$refs.newProductSmallWindow.toggleOpen({ data: data, type: typeProducts })"
            >
              <i class="fas fa-check"></i>
            </b-button>
            <b-button
              v-if="data.item.statusSelected && data.item.statusSelected == 2"
              variant="success"
              size="sm"
              v-b-tooltip.hover
              title="Ativar produto"
              class="mb-2 mr-2"
              @click="ativarProduto(data.item.id)"
            >
              <i class="fas fa-power-off"></i>
            </b-button>
          </span>
        </template>
      </b-table>
      
      <div v-observe-visibility="visibilityChanged">...</div>
    </b-col>

    <b-col cols="12">
      <div v-if="!btnVisible && !menuVisible" class="buttonFixedSave">
        <b-button
          v-if="!isSmallWindow"
          variant="success"
          class="btnFixed"
          @click="save()"
          :disabled="loading || !Object.keys(fields.checkedCheckboxes).length"
        >
          <i class="fas fa-save mr-2"></i>
          SALVAR PRODUTOS SELECIONADOS
        </b-button>
      </div>
    </b-col>

    <b-modal
      ref="detalhesProduto"
      size="xl"
      centered
      hide-footer
      :title="productModal"
      header-bg-variant="orange"
      header-text-variant="light"
    >
      <b-row>
        <b-col cols="12" lg="5" class="slideImg">
          <b-carousel
            style="text-shadow: 0px 0px 2px #000"
            indicators
            img-min-width="200"
            img-max-width="600"
            img-width="auto"
            img-height="auto"
            img-min-height="400"
            img-max-height="600"
            controls
            sliding-start
            sliding-end
            v-if="detalhesP.fotos.length > 0"
          >
            <b-carousel-slide
              v-for="(item, i) in detalhesP.fotos"
              :key="i"
              :img-src="linkFotos(detalhesP.produto.origem) + item.foto_png"
            ></b-carousel-slide>
          </b-carousel>

          <div v-else>
            <h1>Sem imagens</h1>
          </div>
        </b-col>

        <b-col cols="12" lg="7">
          <div
            class="accordion"
            role="tablist"
            v-if="detalhesP.produto != null"
          >
            <b-card-header class="text-center">
                <h4>{{ detalhesP.produto.departamentos }}</h4>
            </b-card-header>
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-1 variant="success"
                  >Detalhes</b-button
                >
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <label>Produto:</label>
                      <input
                        type="text"
                        :value="detalhesP.produto.produto"
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="12" lg="4" class="mb-2">
                      <label>Marca:</label>
                      <input
                        type="text"
                        :value="formatarMarca(detalhesP.produto.marca)"
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="12" lg="4" class="mb-2">
                      <label>Cod. barras:</label>
                      <input
                        type="text"
                        :value="detalhesP.produto.codbar"
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="12" lg="4" class="mb-2">
                      <label>{{
                        typeProducts == 'fixadores'
                          ? 'Un. estoque'
                          : 'Dimensões:'
                      }}</label>
                      <input
                        type="text"
                        :value="
                          typeProducts == 'fixadores'
                            ? detalhesP.produto.unidade
                            : detalhesP.produto.dimensoes
                        "
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="12" class="mb-2">
                      <label>Descrição:</label>
                      <textarea
                        type="text"
                        :value="detalhesP.produto.descricao"
                        class="form-control"
                        rows="3"
                        readonly
                      ></textarea>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1" v-if="detalhesP.fichas.length > 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-2 variant="info"
                  >Ficha técnica</b-button
                >
              </b-card-header>
              <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body class="scrollDiv">
                  <b-row v-for="(item, i) in detalhesP.fichas" :key="i">
                    <b-col cols="12" lg="4" class="mb-2">
                      <input
                        type="text"
                        :value="item.tipo"
                        class="form-control"
                        readonly
                      />
                    </b-col>
                    <b-col cols="12" lg="8" class="mb-2">
                      <div class="inputDescription">{{ item.descricao }}</div>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <NewProductSmallWindow 
      ref="newProductSmallWindow" 
      @updatePage="getValid()"
    />
    <VideoManual ref="videoManual"/>
    <SetSelectedProductPrice
      ref="setSelectedProductPrice"
      @saved="handleSelectedProductPrice($event)"
      @delete="handleSelectedProductPriceDelete($event)"
    />
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import ProductsFilters from './ProductsFilters.vue';
import PageTitle from 'Components/PageTitle.vue';
import InputMoney from 'Components/Inputs/InputMoney.vue';
import VideoManual from '@/components/VideoManual.vue';
import makeToast from '../../../mixins/makeToast';
import SetSelectedProductPrice from './SetSelectedProductPrice.vue';
import UploadProductsSpreadsheet from './UploadProductsSpreadsheet/Index.vue';
import NewProductSmallWindow from './NewProductSmallWindow.vue';

export default {
  name: 'SelectProducts',
  mixins: [makeToast],
  components: {
    ProductsFilters,
    PageTitle,
    InputMoney,
    SetSelectedProductPrice,
    UploadProductsSpreadsheet,
    VideoManual,
    NewProductSmallWindow
  },
  data() {
    return {
      isSmallWindow: false,
      loading: false,
      menssageQtd: 1,
      btnVisible: false,
      menuVisible: false,
      buscaStatus: '',
      filters: {},
      productModal: '',
      typeProducts: 'gerais',
      slideOpts: {
        initialSlide: 0,
        speed: 400,
      },
      detalhesP: {
        fotos: [],
        fichas: [],
        produto: null,
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        lastPage:1,
        total: 1,
      },
      columnHide: {
        marca: false,
        photo: false,
        codbar: false,
        unidade: false
      },
      fields: {
        checkedCheckboxes: {},
        selectedProducts: {},
      },
      table: {
        headers: [
          {
            key: 'actions',
            label: '',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: 'width: 55px;',
            tdStyle: 'width: 55px;',
          },
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'photo',
            label: 'Detalhes',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'produto',
            label: 'Produto',
            thClass: 'text-center',
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
            thClass: 'text-center',
          },
          {
            key: 'marca',
            label: 'Marca',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'unidade', // 'salesFormat1',
            label: 'Tipo',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'priceSalesFormat1',
            label: 'Preço',
            thClass: 'text-center',
          },
           {
            key: 'isExclusivePrice',
            label: 'Exclusivo?',
            thClass: 'text-center',
          },
          {
            key: 'qtdMeters',
            label: 'Qtd m²',
            thClass: 'text-center',
          },
          {
            key: 'withdrawalInOneDay',
            label: 'Retirada em 24h',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'motorcycle',
            label: 'Motoboy',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'isCaliper',
            label: 'Fixador?',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'codInternoAdd',
            label: 'Cód. interno',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'discont',
            label: 'Desconto à vista(%)',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'quantityStock',
            label: 'Gerenciar estoque?',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ],
        records: [],
      },
    };
  },
  created() {
    this.get();
    this.widthWindows();
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
    buscaStatus: function () {
      if (this.buscaStatus != 'marcado') {
        this.table.records = [];
        this.pagination.currentPage = 1;
        this.get();
      }
    },
  },
  methods: {
    ...mapActions('shopkeeper', [
      'saveSelectedProducts',
      'getProducts',
      'getProductsByCategory',
      'getProductsTable',
      'getProductsByFamilyId',
      'getDetalhesProdutoGeral',
      'getDetalhesProdutoFixadores',
      'ativarProdutoLojista',
      'validarCodInternoLojista',
    ]),
    formatarMarca(marca) {
      var titulo =  marca.replace('.jpg', '');
      return titulo.charAt(0).toUpperCase() + titulo.slice(1);
    },
    hideColumn(data){
      this.table.headers.forEach((element, index) => {
        if(element.key == data.field.key){
          this.table.headers[index].tdClass = 'd-none';
          this.table.headers[index].thClass = 'd-none';
          this.columnHide[index] = element.key;
          if(element.key == 'marca'){
            this.columnHide.marca = true
          }
          if(element.key == 'photo'){
            this.columnHide.photo = true
          }
          if(element.key == 'codbar'){
            this.columnHide.codbar = true
          }
          if(element.key == 'unidade'){
            this.columnHide.unidade = true
          }
        }
      });
    },
    showColumn(column){
      this.table.headers.forEach((element, index) => {
        if(element.key == column){
          this.table.headers[index].tdClass = 'text-center';
          this.table.headers[index].thClass = 'text-center';
          if(element.key == 'marca'){
            this.columnHide.marca = false
          }
          if(element.key == 'photo'){
            this.columnHide.photo = false
          }
          if(element.key == 'codbar'){
            this.columnHide.codbar = false
          }
          if(element.key == 'unidade'){
            this.columnHide.unidade = false
          }
        }
      });
    },
    widthWindows() {
      this.isSmallWindow = false;
      var largura = window.screen.width;
      if(largura <= 920){
        this.isSmallWindow = true;
        this.hideColumnSmallWindow();
      }
    },
    hideColumnSmallWindow(){
      this.table.headers.forEach((element, index) => {
        if(element.key == 'withdrawalInOneDay'){
          this.table.headers[index].tdClass = 'd-none';
          this.table.headers[index].thClass = 'd-none';
        }
        if(element.key == 'motorcycle'){
          this.table.headers[index].tdClass = 'd-none';
          this.table.headers[index].thClass = 'd-none';
        }
        if(element.key == 'codInternoAdd'){
          this.table.headers[index].tdClass = 'd-none';
          this.table.headers[index].thClass = 'd-none';
        }
        if(element.key == 'discont'){
          this.table.headers[index].tdClass = 'd-none';
          this.table.headers[index].thClass = 'd-none';
        }
        if(element.key == 'quantityStock'){
          this.table.headers[index].tdClass = 'd-none';
          this.table.headers[index].thClass = 'd-none';
        }
        if(element.key == 'priceSalesFormat1'){
          this.table.headers[index].tdClass = 'd-none';
          this.table.headers[index].thClass = 'd-none';
        }
        if(element.key == 'unidade'){
          this.table.headers[index].tdClass = 'd-none';
          this.table.headers[index].thClass = 'd-none';
        }
        if(element.key == 'codbar'){
          this.table.headers[index].tdClass = 'd-none';
          this.table.headers[index].thClass = 'd-none';
        }
      });
    },
    ativarProduto(id) {
      this.loading = true;
      this.$store.dispatch('startLoader');
      this.ativarProdutoLojista({ userId: this.userTypeId(), productId: id })
        .then((response) => {
          if (response.data.data.error == true) {
            this.makeToast('Oopss', 'Não possível ativar o produto!', 'danger');
          } else {
            this.makeToast('Sucesso', 'Produto ativado!', 'success');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
          this.getValid();
        });
    },
    validItens(item) {
      if (item != null && item.statusSelected == 1) {
        return 'lineSelected';
      } else if (item != null && item.statusSelected == 2) {
        return 'lineDanger';
      }
    },
    verItens(item) {
      if (item != null && item.statusSelected == null) {
        return { id: 'itenNoSelect' + item.id };
      }
    },
    formatMoneyUn(value) {
      var money = parseFloat(value);
      return money.toLocaleString('pt-br', { minimumFractionDigits: 2 });
    },
    visibilityChanged(isVisible) {
      if (!isVisible || this.loading == true) return;
      this.pagination.currentPage = this.pagination.currentPage + 1;
    },
    getValid() {
      this.cleanSelection();
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.get(false);
    },
    linkFotos(origem) {
      if (origem == 'Belenus') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } else {
        return process.env.VUE_APP_FOTOS_URL;
      }
    },
    cleanSelection(cleanFromTable = false) {
      this.fields.checkedCheckboxes = {};

      Object.keys(this.fields.selectedProducts).forEach((key) => {
        if (cleanFromTable)
          this.deleteFromTable(this.fields.selectedProducts[key].id);
        delete this.fields.selectedProducts[key];
      });
    },
    validCodInterno(id) {
      if (!this.fields.selectedProducts[`${id}`].codInterno) return;

      const data = {
        cod: this.fields.selectedProducts[`${id}`].codInterno,
        lojista_id: this.dadosUsuario.id,
      };

      this.loading = true;
      this.$store.dispatch('startLoader');
      this.validarCodInternoLojista(data)
        .then((response) => {
          if (response.data.data.cod == true) {
            this.fields.selectedProducts[`${id}`].codInterno = null;
            this.makeToast(
              'Oopss',
              'Esse código interno já está sendo usado!',
              'danger'
            );
          } else {
            this.makeToast('Sucesso', 'código interno disponível!', 'success');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    deleteFromTable(id) {
      const product = this.table.records.find((x) => x.id === id);
      const index = this.table.records.indexOf(product);
      this.table.records.splice(index, 1);
    },
    openSelectedProductPricesEdit({
      selectedProductId,
      productName,
      productId,
      alreadyCreatedPrices,
    }) {
      this.$refs.setSelectedProductPrice.toggleOpen({
        selectedProductId,
        productName,
        productId,
        alreadyCreatedPrices,
      });
    },
    handleSelection(selected, id, origem) {
      let row = document.getElementById('itenNoSelect' + id);
      if (selected) {
        row.classList.add('lineEdit');
        this.$set(this.fields.selectedProducts, `${id}`, {
          selectedProductId: id,
          priceSalesFormat1: 0,
          priceSalesFormat2: 0,
          quantityStock: null,
          codInterno: null,
          quantityValid: false,
          withdrawalInOneDay: false,
          motorcycle: false,
          isExclusivePrice: false,
          isCaliper: false,
          discont: null,
          customPrices: [],
          origem: origem.familia != undefined ? 'fixadores' : 'geral',
        });
        return;
      } else {
        row.classList.remove('lineEdit');
      }

      this.$set(this.fields.selectedProducts, `${id}`, null);
      delete this.fields.selectedProducts[`${id}`];
    },
    save() {
      if (
        !this.fields.selectedProducts ||
        !Object.keys(this.fields.selectedProducts).length
      )
        return;

      this.$store.dispatch('startLoader');

      const request = {
        userId: this.userTypeId(),
        selectedProducts: [],
      };

      let isValid = true;
      var msg = '';
      Object.keys(this.fields.selectedProducts).forEach((key) => {
        if (
          (this.fields.selectedProducts[key].quantityValid == true &&
            this.fields.selectedProducts[key].quantityStock == null) ||
          0
        ) {
          isValid = false;
          msg = 'Você precisa ter 1 item em estoque!';
          return;
        } else if (
          this.fields.selectedProducts[key].priceSalesFormat1 == 'R$0,00'
        ) {
          isValid = false;
          msg = 'O valor não pode ser R$0,00!';
          return;
        }
      });

      if (!isValid) {
        this.makeToast('Oopss', msg, 'danger');
        this.$store.dispatch('endLoader');
        return;
      }

      if (this.filters.tipo == 'fixadores') {
        var dep =
          this.filters.departments2.departmentId +
          ',' +
          this.filters.departments3.departmentId +
          ',' +
          this.filters.departments4.departmentId +
          ',' +
          this.filters.departments5.departmentId +
          ',' +
          this.filters.departments6.departmentId;
        request.deps = dep;

        request.familia_id = this.filters.family;
      }

      Object.keys(this.fields.selectedProducts).forEach((key) => {
        this.fields.selectedProducts[key].discont = parseInt(this.fields.selectedProducts[key].discont)
        request.selectedProducts.push(this.fields.selectedProducts[key]);
      });

      this.saveSelectedProducts(request)
        .then(() => {
          this.makeToast('Sucesso', 'Produtos selecionados salvos com sucesso');
          this.$root.$emit('valid-available-app');
          this.cleanSelection(true);
          this.table.records = [];
          this.pagination.currentPage = 1;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.get();
        });
    },
    get(status = true) {
      let marca = '';
      if (this.filters.brand) {
        marca = this.filters.brand.marca;
      } else {
        marca = '';
      }

      if (this.loading) return;

      if (status == false) {
        this.buscaStatus = '';
      }

      this.typeProducts = 'gerais';
      if (this.filters.tipo == 'fixadores') {
        this.table.records = [];
        this.typeProducts = 'fixadores';
      }

      this.loading = true;
      this.$store.dispatch('startLoader');
      this.getProductsByFamilyId({
        familyId: this.filters.family || 0,
        currentPage: this.pagination.currentPage,
        productName: this.filters.name,
        tipo: this.filters.tipo,
        userId: this.userTypeId(),
        brand: marca,
        status: this.buscaStatus,
      })
        .then((response) => {
          const { per_page, total, last_page } = response.data.data || {};
          this.pagination.itemsPerPage = per_page || 15;
          this.pagination.total = total || 15;
          this.pagination.lastPage = last_page
          this.table.records.push(...response.data.data.data);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    handleSelectedProductPrice(event) {
      if (!event.productId) return;

      if (!this.fields.selectedProducts[event.productId].customPrices) {
        this.fields.selectedProducts[event.productId].customPrices = [];
      }

      this.fields.selectedProducts[event.productId].customPrices.push({
        ...event,
      });
    },
    handleSelectedProductPriceDelete(event) {
      if (!event.productId) return;

      const currentCustomPrices =
        this.fields.selectedProducts[event.productId].customPrices || [];

      if (!currentCustomPrices.length) {
        return;
      }
    },
    formatMarca(marca) {
      if(marca != null && marca.match(/jpg/)){
        const result = marca.split('.jpg');
        return result[0];
      }

      return marca;
    },
    showModal(productId, product, familiaId='') {
      this.productModal = product;

      if (this.typeProducts == 'fixadores' || familiaId != '') {
        this.buscarDetalhesFixadores(productId);
      } else {
        this.buscarDetalhesGerais(productId);
      }
    },
    buscarDetalhesGerais(productId) {
      this.$store.dispatch('startLoader');

      const data = {
        productId: productId,
        lojistaId: this.dadosUsuario.id
      }

      this.getDetalhesProdutoGeral(data)
        .then((response) => {
          this.detalhesP.fichas = response.data.ficha;
          this.detalhesP.fotos = response.data.fotos;
          this.detalhesP.produto = response.data.produto;
          this.$refs['detalhesProduto'].show();
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Erro ao buscar detalhes do produto!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    buscarDetalhesFixadores(productId) {
      this.$store.dispatch('startLoader');
      this.getDetalhesProdutoFixadores(productId)
        .then((response) => {
          this.detalhesP.fichas = response.data.ficha;
          this.detalhesP.fotos = response.data.fotos;
          this.detalhesP.produto = response.data.produto;
          this.$refs['detalhesProduto'].show();
        })
        .catch(() => {
          this.makeToast('Opss','Erro ao buscar detalhes do produto!','danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    hideModal() {
      this.productModal = '';
      this.detalhesP.fichas = [];
      this.detalhesP.fotos = [];
      this.detalhesP.produto = null;
      this.$refs['detalhesProduto'].hide();
    },
    pagePosition(isVisible) {
      this.btnVisible = isVisible;
    },
    menuPosition(isVisible) {
      this.menuVisible = isVisible;
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission() {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name == NamePermission.SELECIONAR_PRODUTO
        );

        if (
          this.$route.meta.userType == UserTypes.BALCONISTA &&
          permission.type == TypePermission.BALCONISTA
        ) {
          return false;
        }
      }
      return true;
    },
    textWrap(text){
      if(!this.btnVisible && !this.menuVisible){
        if(text.includes('Gerenciar')) {
          return 'Ger. Estoque';
        }
        if(text.includes('Desconto')) {
          return 'Desc. à vista(%)';
        }
        if(text.includes('Retirada')) {
          return 'Retirada(24h)';
        }
        return text;
      }
      return text;
    }
  },
};
</script>

<style scoped>
.imgWidth {
  width: 50px;
  cursor: pointer;
}
.imgModal {
  max-width: 800px;
  max-height: 800px;
  width: auto;
  height: auto;
}
.btnAcaoProd {
  height: 50px;
  padding: 0 20px;
}
.slideImg {
  display: flex;
  justify-content: center;
  align-items: center;
}
.scrollDiv {
  overflow: scroll;
  height: 300px;
}
.btnFixed {
  height: 50px;
  width: 343px;
  padding: 0 20px;
  margin-left: -50px;
}
.buttonFixedSave {
  right: 20px;
  z-index: 900;
  position: fixed;
  bottom: 30px;
}
.itensText {
  cursor: pointer;
  padding: 3px 15px;
  border-radius: 3px;
  margin-right: 5px;
}
.headTableFixed{
  background: rgb(255, 255, 255);
  z-index: 1;
  position: fixed;
  width:100vw;
  height: 85px;
  top: 49px;
  margin-left: -13px;
  text-align: start;
}
.headTable{
  background: white;
  border: none;
  padding: 0;
}
.lineSelectedWarning {
  background-color: #ffc107ab !important;
  color: rgba(0, 0, 0, 0.708) !important;
}

.inputDescription {
  border: solid 1px; 
  padding: 4px 6px; 
  border-color: rgba(128, 128, 128, 0.514);
  
}
</style>
